const navbarBtnMenu = document.querySelector(".navbar__btn--menu");

navbarBtnMenu.addEventListener("click", (e) => {
  const menu = document.querySelector(".menu");

  if (menu.style.height == "0px") {
    menu.style.height = "300px";
  } else {
    menu.style.height = "0px";
  }
});
